module.exports = __webpack_public_path__ + "media/images/icons/zoom-in-78bcf0c15cfbdedc0815e60818f0a34b.svg";